export const formatRoas = (n) => (typeof n === "number" ? n.toFixed(2) : "—");

export const formatMoney = (n) =>
  typeof n === "number"
    ? n.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 })
    : "—";

export const calcBreakEven = (sp, cogs, oc) => {
  const margin = sp - cogs - oc;
  if (!margin || margin <= 0) return 0;
  return sp / margin;
};

export const signalMeta = (signal) => {
  const s = (signal || "").toLowerCase();
  if (s === "scale") return { label: "SCALE", className: "scale-bg", color: "#15803d", emoji: "▲" };
  if (s === "stop") return { label: "STOP", className: "stop-bg", color: "#b91c1c", emoji: "■" };
  return { label: "HOLD", className: "hold-bg", color: "#a16207", emoji: "●" };
};

export const calcSignalClient = (buffer, recent = []) => {
  if (recent.length < 3) {
    if (buffer < 0) return "stop";
    if (buffer < 0.5) return "hold";
    return "scale";
  }
  const diff = recent[recent.length - 1] - recent[0];
  const trend = diff > 0.05 ? "rising" : diff < -0.05 ? "falling" : "stable";
  if (buffer < 0) return "stop";
  if (buffer > 0.5 && (trend === "rising" || trend === "stable")) return "scale";
  return "hold";
};

export const actionPlan = (signal, buffer) => {
  const s = (signal || "").toLowerCase();
  if (s === "stop") {
    return {
      headline: "Cut spend now",
      body: "You are losing money on every dollar spent. Cut spend by at least 50% or pause entirely. Do not scale until you fix your creative, offer, or targeting. Log again next week to track recovery.",
    };
  }
  if (s === "scale") {
    if (buffer > 1.0) {
      return {
        headline: "Strong buffer — push spend",
        body: "Your buffer is strong. Consider increasing ad budget by 25-35% this week. Avoid going higher than 35% in one jump — give the algorithm time to adjust.",
      };
    }
    return {
      headline: "Healthy buffer — scale moderately",
      body: "You have a healthy buffer. A 15-20% budget increase is reasonable this week. Monitor closely for the first 2-3 days after scaling.",
    };
  }
  // hold
  if (buffer < 0.1) {
    return {
      headline: "Barely breaking even",
      body: "You are barely breaking even. Do not increase spend. Consider pausing your lowest performing ad sets and consolidating budget into what is working.",
    };
  }
  return {
    headline: "Thin margin — hold steady",
    body: "You are profitable but your margin is thin. Keep spend flat this week and log again before making any changes. Look for ways to improve your margins or creative performance.",
  };
};
